import { useContext, useState } from "react"
import getServices from "../services/getServices"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"

const useAcompanhamentoState = () => {

    const formatDate = (date) => date.toISOString().split('T')[0];

    const hoje = new Date();
    const primeiroDia = new Date(hoje);
    primeiroDia.setDate(primeiroDia.getDate() - 1);
    const ultimoDia = new Date(hoje);

    const { signOut, user } = useContext(AuthContext)
    const [tarefa, setTarefa] = useState([])
    const [submit, setSubmit] = useState(false)
    const [dataInicial, setDataInicial] = useState(formatDate(primeiroDia));
    const [dataFinal, setDataFinal] = useState(formatDate(ultimoDia));    

    const _getTarefa = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let filters = {
            data_inicial: dataInicial || undefined,
            data_final: dataFinal || undefined,            
        };

        Object.keys(filters).forEach(key => {
            if (filters[key] === null || filters[key] === '') {
            delete filters[key];
            }
        });


        let result = await getServices('admin/ultimatarefausuario/',filters);
        if (result.type === 'success'){
            const tarefasOrdenadas = result.data
                .sort((a, b) => new Date(b.entrada) - new Date(a.entrada)) // ordena por entrada desc
                .map(item => ({
                    id: item.id,
                    nome: item.local_name,
                    posto: item.posto,
                    // Padroniza tarefas sem tipo com o nome funcional Check-in.
                    tipo: String(item.tipotarefa_nome || '').trim() || 'Check-in',
                    in_out: item?.saida ? "Check-out" : "Check-in",
                    tem_formulario: item.tipotarefa?.tem_formulario,
                    usuario: item?.usuario_nome,
                    entrada: item?.entrada,
                    saida: item?.saida,
                    latitude: item?.latitude,
                    longitude: item?.longitude,
                    foto: null
                }));

                setTarefa(tarefasOrdenadas);                     
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else {
            toast.error(result.data?.detail || 'Não foi possível carregar o acompanhamento.')
        }
        setSubmit(false)
    }
    return {
        tarefa: {value: tarefa, set:_getTarefa},
        submit: {value: submit, set: _getTarefa},
        dataInicial: { value: dataInicial, set: setDataInicial },
        dataFinal: { value: dataFinal, set: setDataFinal },        
    }
}

export default useAcompanhamentoState
